import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Container, Modal, Nav } from 'react-bootstrap'
import { Pagination } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../app/stores/store'
import Navigation from '../components/Navigation'
import FooterNew from '../components/Footer'
import PostCard from '../components/post/PostCard'
import { FilterModes, PopUpMode } from '../../app/models/modes'
import ComponentLoader from '../components/loaders/ComponentLoader'
import PostPopUp from './PopUp/PostPopUp'

function PostList() {
  const { postListStore, methodsStore } = useStore()
  const { posts } = postListStore
  const { showCreatePost, setShowCreatePost } = methodsStore
  const [loadingInit, setLoadingInit] = useState(true)
  const [page, setPage] = useState(1)
  const paginatePosts = 9
  const { t } = useTranslation()

  useEffect(() => {
    if (loadingInit) {
      postListStore.loadPosts().finally(() => {
        setLoadingInit(false)
      })
    }
  }, [loadingInit, postListStore])

  function paginate(array: any) {
    return array.slice((page - 1) * paginatePosts, page * paginatePosts)
  }

  if (loadingInit) return <ComponentLoader mTop={100} />

  return (
    <>
      <Navigation type={FilterModes.post} />

      <Container fluid className='auction-container'>
        <div className='d-flex justify-content-center mt-3'>
          <Nav.Link>
            <button
              className='add-auction-btn'
              onClick={() => methodsStore.setShowCreatePost(true)}
            >
              <i className='fa-solid fa-plus' /> {t('add_post')}
            </button>
          </Nav.Link>
        </div>
        <div className='auction-content'>
          {posts.length === 0 && <h3 className='mt-5 text-center'>{t('no_posts')}</h3>}
          <div className='auction-list mb-5'>
            {paginate(posts.map((post, index) => <PostCard key={index} post={post} />))}
          </div>
          {posts.length > 0 && (
            <Pagination
              color='primary'
              className='auctions-pagination mb-5'
              sx={{
                width: '100%',
                '& .MuiPaginationItem-root.Mui-selected, .MuiPaginationItem-root.Mui-selected:hover':
                  {
                    backgroundColor: '#4f7f71',
                  },
              }}
              page={page}
              size='large'
              onChange={(e, value) => setPage(value)}
              count={Math.ceil(posts.length / paginatePosts)}
            />
          )}
        </div>
      </Container>
      <FooterNew />

      {/* Create Post Modal */}
      <Modal
        className='test01'
        size='lg'
        centered
        show={showCreatePost}
        onHide={() => setShowCreatePost(false)}
      >
        <PostPopUp handleClosePost={() => setShowCreatePost(false)} postPopUpMode={PopUpMode.Create} />
      </Modal>
    </>
  )
}

export default observer(PostList)
